import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const StatsCard = ({ label, value, icon, subtitle }) => {
  const { resolvedTheme } = useTheme();
  const dark = resolvedTheme === 'dark';

  return (
    <div className={`p-5 rounded-xl border ${dark ? 'bg-[#1A1A1A] border-[#333]' : 'bg-white border-gray-200'}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className={`text-xs font-medium uppercase tracking-wider ${dark ? 'text-gray-500' : 'text-gray-400'}`}>
            {label}
          </p>
          <p className={`text-2xl font-bold mt-1 ${dark ? 'text-white' : 'text-gray-900'}`}>
            {value}
          </p>
          {subtitle && (
            <p className={`text-xs mt-1 ${dark ? 'text-gray-500' : 'text-gray-400'}`}>
              {subtitle}
            </p>
          )}
        </div>
        {icon && (
          <div className={`p-2 rounded-lg ${dark ? 'bg-[#FF9800]/10 text-[#FF9800]' : 'bg-indigo-50 text-indigo-600'}`}>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={icon} />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
